// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2RHZu","bigColWidth":"Table_bigColWidth__dvfuB","biggerColWidth":"Table_biggerColWidth__1AUCz","row":"Table_row__3tURY","col":"Table_col__2396V"};